import React from 'react'
import { TreeSelect } from 'antd';

const SearchSelect = ({ treeData,value,label,onChangeValue }) => {


  const onChange = (value) => {
    onChangeValue(value)
    // console.log(e)

  };
  const onPopupScroll = (e) => {
    console.log('onPopupScroll', e);
  };

  return (
    <div className='d-flex flex-column gap-2'>
      <label>{label}</label>
      <TreeSelect
        showSearch
        placeholder={`Search to ${label}`}
        onChange={onChange}
        style={{
          width: '100%',
        }}
        value={value}
        dropdownStyle={{
          maxHeight: 400,
          overflow: 'auto',
        }}

        allowClear
        treeDefaultExpandAll
        treeData={treeData}
        onPopupScroll={onPopupScroll}
      
      />
    </div>
  )
}

export default SearchSelect
